import React, { Fragment } from "react";
export function Header(){
    return (
        <Fragment>
  {/* Header */}
  <header id="header">
    <div className="inner">
      {/* Logo */}
      <a href="/" className="logo">
        <span className="symbol"><img src="images/p.png" alt="Promise Shedrach" /></span><span style={{fontSize: 11}}>Promise shedrach</span>
      </a>
      {/* Nav */}
      <nav> 
        <ul>
          <li><a href="#menu">Menu</a></li>
        </ul>
      </nav>
    </div>
  </header>
  {/* Menu */}
  <nav id="menu">
    <header id="header">
      <div className="inner">
        {/* Logo */}
        <a href="/" className="logo" style={{textAlign: 'center'}}>
          <span className="symbol"><img src="images/p.png" alt="Promise Shedrach" /></span><span style={{fontSize: 11}}>Promise shedrach</span>
        </a>
      </div>
    </header>
    <ul>
      <li><a href="/">Home</a></li>
      <li><a href="/about-me">About Me</a></li>
      <li><a href="my-works">My Works</a></li>
      <li><a href="testimonials"> Testimonials </a></li>
    </ul>
  </nav>

        </Fragment>
    )
}